import { CreateAdvertisement } from "@cryptors/api-client";
import { Box, TextField } from "@mui/material";
import { IResourceComponentsProps } from "@refinedev/core";
import { HttpError } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";

import UploadButton from "@/components/forms/UploadButton";
import { upload } from "@/utils/upload";

interface AdvertisementCreateEditProps extends IResourceComponentsProps {
  isEditing?: boolean;
}

export const AdvertisementCreateEdit: React.FC<
  AdvertisementCreateEditProps
> = () => {
  const {
    refineCore: { formLoading, onFinish },
    register,
    formState: { errors, isValid, isDirty },
    control,
    handleSubmit,
    setError,
  } = useForm<CreateAdvertisement, HttpError, CreateAdvertisement>();

  const onFinishHandler = (data: CreateAdvertisement) => {
    onFinish({
      title: data.title,
      url: data.url === "" ? null : data.url,
      image: { url: data.image.url },
    });
  };

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{
        onClick: handleSubmit(onFinishHandler),
        disabled: !isDirty || !isValid,
      }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("title", { required: "Ce champ est requis" })}
          defaultValue={null}
          error={!!errors.title}
          helperText={errors.title?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Titre"
          name="title"
        />
        <TextField
          {...register("url")}
          defaultValue={null}
          error={!!errors.url}
          helperText={errors.url?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Lien externe"
          name="url"
        />
        <Controller
          control={control}
          name="image.url"
          rules={{ required: "Ce champ est requis" }}
          render={({ field, fieldState }) => (
            <UploadButton
              id="image"
              inputSrc={field.value}
              uploadButtonLabel="Upload Image"
              onError={() =>
                setError("image.url", {
                  message: "L'upload a échoué. Veuillez réessayer",
                })
              }
              onChange={async (event) => {
                const url = await upload(event, "advertisements");
                field.onChange(url);
              }}
              errorMessage={fieldState.error?.message}
            />
          )}
        />
      </Box>
    </Create>
  );
};
